<template>
  <ul v-auto-animate="autoAnimateFade" :class="classNames.root">
    <li v-for="(hint, index) in fixedHints" v-text="hint" :key="index" :class="classNames.hint" />
    <li v-for="(error, index) in fixedErrors" :key="index" :class="classNames.errors">
      <slot v-bind="{ error }" name="errors">
        {{ error }}
      </slot>
    </li>
  </ul>
</template>

<script setup lang="ts">
export interface UiErrorStackClasses {
  root: ClassValue
  hint: ClassValue
  errors: ClassValue
}

export interface UiErrorStackProps {
  class?: ClassValue
  classes?: Partial<UiErrorStackClasses>
  hints?: string[]
  errors?: string | string[]
}

const props = defineProps<UiErrorStackProps>()

function clearEmptyArrayValues<T>(arr: T[] | undefined): TSReset.NonFalsy<T>[] | undefined {
  return arr?.filter(Boolean)
}
const fixedHints = computed(() => clearEmptyArrayValues(props.hints))
const fixedErrors = computed(() => clearEmptyArrayValues(toArray(props.errors)))

const classNames = computed(() => {
  return {
    root: cn("flex flex-col gap-1.5 text-sm leading-4", props.classes?.root, props.class),
    errors: cn("text-destructive pt-1.5 text-sm", props.classes?.errors),
    hint: cn("pt-1.5 text-black/50", props.classes?.hint),
  }
})
</script>
